module.exports = __webpack_public_path__ + "img/form2img.fd890a0f.png";